import { HashRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import MerchantInvoice from "../pages/MerchantInvoice/MerchantInvoiceList";
import CreateMerchantInvoice from "../pages/MerchantInvoice/CreateMerchantInvoice";
import EditMerchantInvoice from "../pages/MerchantInvoice/EditMerchantInvoice";
import MerchnatInvoicePreview from "../pages/MerchantInvoice/MerchantInvoicePreview";
//@ts-ignore
import {
  AccessControl,
  PermissionRequired,
} from "@careinfo/permission-required";
import CargoMerchantInvoicePreview from "../pages/MerchantInvoice/CargoMerchantInvoicePreview";
import MerchantFileUpload from "../pages/MerchantInvoice/MerchantFileUpload";
export const queryClient = new QueryClient();

const MerchantInvoiceRouter = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route path={"/"} element={<MerchantInvoice />} />
          <Route
            path={"/create"}
            element={
              <AccessControl
                children={<CreateMerchantInvoice />}
                allowedPermissions={["can_create_merchant_invoice"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />

          <Route path={"/edit/:id"} element={<EditMerchantInvoice />} />
          <Route path={"/preview/:id"} element={<MerchnatInvoicePreview />} />
          <Route
            path={"/cargo-preview/:id"}
            element={<CargoMerchantInvoicePreview />}
          />
          <Route path={"/documents/:id"} element={<MerchantFileUpload />} />
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={500} draggablePercent={30} />
    </QueryClientProvider>
  );
};

export default MerchantInvoiceRouter;
